angular.module('bmsApp.settings').factory('SMCleaningServiceCategorySvc', function ($rootScope, $http, $log, $window, $q, CRUDSvc, $modal) {
	return {
		index: function (params) {
			return CRUDSvc.get('api/sm/cleaningServiceCategory/index', params);
		},
		save: function (params) {
			return CRUDSvc.post('api/sm/cleaningServiceCategory/save', params);
		},
		remove: function (params) {
			return CRUDSvc.post('api/sm/cleaningServiceCategory/remove', params);
		},
		options: function (data) {
			return CRUDSvc.get('api/sm/cleaningServiceCategory/options', data);
		}
	}
});




